import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import { getApiUrl } from '@/utils/apiUrl';
const API_URL = getApiUrl();

const DomainLanding = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const hostname = window.location.hostname.toLowerCase();
    const path = location.pathname;
    
    // Preview environment
    if (hostname.endsWith('.emergentagent.com')) {
      navigate('/login', { replace: true });
      return;
    }

    // Check if it's a subdomain of elsette.com
    if (hostname.endsWith('.elsette.com') && hostname !== 'www.elsette.com' && hostname !== 'elsette.com') {
      resolveSubdomain(hostname);
      return;
    }
    
    // For custom domains (loja publica), try to resolve
    if (hostname !== 'elsette.com' && hostname !== 'www.elsette.com' && hostname !== 'localhost' && hostname !== '127.0.0.1') {
      // Check if path could be a vitrine slug (non-root, single segment)
      if (path && path !== '/' && !path.startsWith('/p/') && !path.startsWith('/produto/')) {
        const slug = path.replace(/^\//, '').replace(/\/$/, '');
        if (slug && !slug.includes('/')) {
          navigate(`/vitrine/${slug}`, { replace: true });
          return;
        }
      }
      resolveCustomDomain(hostname);
      return;
    }

    // elsette.com or www.elsette.com — should not reach here (Cloudflare blocks it)
  }, [navigate, location.pathname]);

  const resolveSubdomain = async (hostname) => {
    navigate('/login', { replace: true });
  };

  const resolveCustomDomain = async (hostname) => {
    try {
      const response = await fetch(`${API_URL}/api/domains/resolve/${hostname}`);
      const data = await response.json();
      
      if (data.type === 'store' && data.product_id) {
        navigate(`/p/${data.product_id}`, { replace: true });
      } else if (data.type === 'store') {
        console.warn('Custom domain resolved but no product_id found');
      }
    } catch (error) {
      console.error('Error resolving domain:', error);
    }
  };

  return null;
};

export default DomainLanding;
